export default __webpack_public_path__ + "static/ThaiBMA_logo-96f23b31955761dd99c59edc43ba9356.png";